/**
 * Simple auth helper for demo - mock login
 * Mock credentials: admin / 123456
 */
import Vue from 'vue'
import { setToken } from '@/utils/request'

export const authBus = new Vue()

const STORAGE_KEY = 'ds-user'

export const MOCK_CREDENTIALS = [
  { account: 'admin', password: '123456', nickname: '点石用户', vipType: 'svip' },
  { account: 'test', password: '123456', nickname: '测试用户', vipType: null },
]

export function getUser() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function saveUser(user) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(user))
  authBus.$emit('user-login', user)
}

export function logout() {
  localStorage.removeItem(STORAGE_KEY)
  setToken('')
  authBus.$emit('user-logout')
}

export function isSvipUser() {
  const u = getUser()
  return !!(u && u.vipType === 'svip')
}

/**
 * 是否 SVIP：以本地缓存 ds-user 中 member.currentLevelId === 3 为准（与后端等级一致）
 */
export function isSvipMemberFromCache() {
  const u = getUser()
  if (!u || !u.member || typeof u.member !== 'object') return false
  const id = u.member.currentLevelId
  if (id === 3 || id === '3') return true
  const n = Number(id)
  return Number.isFinite(n) && n === 3
}

export function checkCredentials(account, password) {
  const a = String(account || '').trim().toLowerCase()
  const p = String(password || '')
  const found = MOCK_CREDENTIALS.find(
    c => (c.account.toLowerCase() === a || c.account === account) && c.password === p
  )
  return found ? { nickname: found.nickname, userId: 'DS' + Date.now().toString(36).toUpperCase(), vipType: found.vipType } : null
}
